import { useCallback, useState } from "react";
import { cfFetch } from "../api/apiClient";
import type { Currency } from "../types";

type Scenario = "bad" | "mid" | "good";

export type ForecastInsights = {
  recurringSuggestions: Array<Record<string, unknown>>;
  growthHints: Array<Record<string, unknown>>;
  anomalies: Array<Record<string, unknown>>;
  scenarioIdeas: Array<Record<string, unknown>>;
  explanation: string;
  source: "AI" | "fallback";
};

export function useForecastInsights() {
  const [insights, setInsights] = useState<ForecastInsights | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(
    async (scenario: Scenario, currency: Currency) => {
      setIsLoading(true);
      try {
        const res = await cfFetch(
          `/forecast/llm/insights?scenario=${scenario}&displayCurrency=${encodeURIComponent(currency)}`,
        );
        const json = await res.json();
        if (!res.ok) {
          throw new Error(
            json?.detail?.error || "Failed to load forecast insights",
          );
        }
        setInsights(json as ForecastInsights);
        return json as ForecastInsights;
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return { insights, isLoading, refresh };
}
